import React from "react";

/**
 * ELWIS logo — wordmark + waveform symbol.
 * Three concentric arcs evoke wireless energy transfer;
 * the vertical bar represents grounded infrastructure.
 */
export const Logo = ({ variant = "dark", className = "", showWordmark = true }) => {
    const fg = variant === "dark" ? "#FFFFFF" : "#050B14";
    const accent = "#00E5FF";

    return (
        <span
            className={`inline-flex items-center gap-2.5 ${className}`}
            data-testid="elwis-logo"
        >
            <svg
                width="28"
                height="28"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                {/* Infrastructure base */}
                <rect x="14.5" y="6" width="3" height="20" rx="0.5" fill={fg} />
                {/* Wireless arcs */}
                <path
                    d="M9 11 Q 6 16 9 21"
                    stroke={accent}
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                />
                <path
                    d="M5 8 Q 0 16 5 24"
                    stroke={fg}
                    strokeOpacity="0.6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    fill="none"
                />
                <path
                    d="M23 11 Q 26 16 23 21"
                    stroke={accent}
                    strokeWidth="2"
                    strokeLinecap="round"
                    fill="none"
                />
                <path
                    d="M27 8 Q 32 16 27 24"
                    stroke={fg}
                    strokeOpacity="0.6"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    fill="none"
                />
            </svg>
            {showWordmark && (
                <span
                    className="font-display font-black tracking-[0.08em] text-[1.05rem] leading-none"
                    style={{ color: fg }}
                >
                    ELWIS
                </span>
            )}
        </span>
    );
};

export default Logo;
